import Masonry from "masonry-layout";
import imagesLoaded from "imagesloaded";
import Vue from "vue/dist/vue.js";

export default class HelpListing {
  constructor() {
    console.log("HelpListing :: init");

    new Vue({
      el: "#help-listing",
      data() {
        return {
          helpLength: 6,
          helps: [],
          msnry: "",
          filterChoices: [],
          filtersToSend: [],
          baseUrl: window.location.origin + window.location.pathname,
          language: document.documentElement.getAttribute("lang").substring(0, 2),
        };
      },
      mounted() {
        this.helps = this.$refs.listing.querySelectorAll(".bloc-post");
        this.filterChoices = this.$refs.main.querySelectorAll(".filter");

        if (window.location.search != "") {
          let params;
          if (window.location.search.search("%7C") != -1) {
            params = window.location.search.substring(window.location.search.indexOf("=") + 1).split("%7C");
          } else {
            params = window.location.search.substring(window.location.search.indexOf("=") + 1).split("|");
          }
          for (const param of params) {
            for (const filter of this.filterChoices) {
              if (filter.getAttribute("data-choice") === param) {
                filter.classList.add("selected");
                this.filtersToSend.push(filter.dataset.choice);
                // this.getHelps();
                this.$refs.main.querySelector("#filterAll").classList.remove("selected");
              }
            }
          }
        }

        this.activateMasonry();
      },
      methods: {
        loadmore() {
          this.helpLength += 3;
          this.showHelps();
        },
        showHelps() {
          for (let i = 0; i < this.helps.length; i++) {
            if (this.helps[i] && this.helps[i].style) {
              if (i > this.helpLength - 1) {
                this.helps[i].style.display = "none";
              } else {
                this.helps[i].style.display = "";
              }
            }
          }

          if (this.helpLength >= this.helps.length) {
            this.$refs.loadmore.style.display = "none";
          }
          this.msnry.layout();
        },

        onFilterClick(e) {
          e.preventDefault();
          let target = e.target;
          // this.$refs.listing.style.opacity = "0";

          // Pour avoir un filtre "Toutes les aides"
          if (target.dataset.choice == "all") {
            for (let i = 0; i < this.filterChoices.length; i++) {
              this.filterChoices[i].classList.remove("selected");
            }
          } else {
            this.$refs.main.querySelector("#filterAll").classList.remove("selected");
          }

          if (target.classList.contains("selected")) {
            target.classList.remove("selected");
          } else {
            let activeChoices = this.$refs.main.querySelectorAll(".filter.selected");

            if (activeChoices) {
              for (let i = 0; i < activeChoices.length; i++) {
                if (activeChoices[i].classList.contains("selected")) {
                  activeChoices[i].classList.toggle("selected");
                }
              }
            }
          }
          target.classList.add("selected");

          this.getHelps();
        },

        getHelps() {
          this.getChoices();

          let paramString = "";

          for (const param of this.filtersToSend) {
            paramString += param + "|";
          }

          const lastIndexOfL = paramString.lastIndexOf("|");
          const finalString = paramString.slice(0, lastIndexOfL) + paramString.slice(lastIndexOfL + 1);

          const category = this.filtersToSend[0] == "all" ? "" : this.filtersToSend[0];
          const categoryString = this.language == "fr" ? "?categorie=" : "?category=";

          if (finalString != "") {
            window.history.replaceState(
              null,
              document.title,
              this.baseUrl + categoryString + encodeURIComponent(category)
            );
          } else {
            window.history.replaceState(null, document.title, this.baseUrl);
          }

          axios
            .get("/wp-admin/admin-ajax.php?action=filterChronoAide", {
              params: {
                category: this.filtersToSend[0],
                lang: window.location.pathname,
              },
            })
            .then((response) => {
              //Emit response to parent
              if (response.data.success) {
                this.serveHelps(response.data);
                this.helps = response.data.aides;
              } else console.error("Filters :: Failed to retrieve questions");
            })
            .catch((err) => console.error(err));
        },

        getChoices() {
          this.filtersToSend = [];

          let activeChoices = this.$refs.main.querySelectorAll(".filter.selected");

          for (let i = 0; i < activeChoices.length; i++) {
            this.filtersToSend.push(activeChoices[i].dataset.choice);
          }

          if (this.filtersToSend.length == 1 && this.filtersToSend[0] == "all") {
            this.filtersToSend = [];
          }
        },

        serveHelps(response) {
          const helps = response.aides;
          const that = this;

          if (helps.length) {
            // this.$refs.listing.innerHTML = "";

            this.msnry.remove(this.msnry.getItemElements());
            for (let i = 0; i < helps.length; i++) {
              const help = helps[i];

              let newHelp = `
                    <div class="thumbnail-wrapper">
                        <img class="thumbnail" src="${help.image.url}"
                            alt="${help.image.alt}" />
                    </div>
                    <div class="wrapper-text">
                        <h3>
                        ${help.title}
                        </h3>
                        <p class="date">
                        ${new Date(help.date).toLocaleDateString(`${this.language === "fr" ? "fr-fr" : "us-en"}`, {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}
                        </p>
                        <p class="excerpt">
                            ${help.content.substring(0, 200)}
                        </p>
                    </div>
                `;

              // this.$refs.listing.insertAdjacentHTML("beforeend", newHelp);

              const newHelpElement = document.createElement("a");
              newHelpElement.classList.add("bloc-post");
              newHelpElement.classList.add("help");
              newHelpElement.setAttribute("href", help.url);
              newHelpElement.innerHTML = newHelp;

              this.$refs.listing.appendChild(newHelpElement);
              this.msnry.appended(newHelpElement);
            }

            Vue.nextTick(function () {
              that.msnry.layout();
            });
            this.$refs.listing.style.opacity = "1";
          }
        },

        activateMasonry() {
          imagesLoaded(".help-list", (instance) => {
            this.msnry = new Masonry(".help-list", {
              itemSelector: ".bloc-post",
              percentPosition: true,
              columnWidth: ".bloc-post",
              gutter: ".gutter-sizer",
            });
            //remove opacity class
            document.querySelector(".help-list").classList.remove("transparent");
            this.showHelps();
          });
        },
      },
    });
  }
}
